import { AdvancedSnapshotExportRequestParams, AdvancedSnapshotExportResponse } from '@/pages/OperationsInsights/types/AdvancedSnapshot';
import { formatISO } from 'date-fns';
import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';

export function fetchAdvancedSnapshotExportUrl(query: AdvancedSnapshotExportRequestParams) {
    const params = new URLSearchParams({
        type: query.type,
        workstreamDefinitionIds: query.workstreamDefinitionIds?.join(','),
        snapshotDate: formatISO(query.snapshotDate, { representation: 'date' }),
    });
    if (query.expiresIn) params.append('expiresIn', query.expiresIn.toString());

    return fetchFromLambda<AdvancedSnapshotExportResponse>(`/workactivity/back-office/backlog/advanced-snapshots/export?${params}`);
}
